import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/newsletter`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const box = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 18 };
const btn = (bg) => ({ background: bg, color: '#fff', border: 0, borderRadius: 6, padding: '9px 16px', fontWeight: 600, cursor: 'pointer', marginRight: 8, marginBottom: 6 });
const th = { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #e5e7eb', fontSize: 13, color: '#555' };
const td = { padding: '8px 10px', borderBottom: '1px solid #f0f0f0', fontSize: 14 };

export default function NewsletterPage() {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [editions, setEditions] = useState([]);
  const [subs, setSubs] = useState([]);
  const [count, setCount] = useState(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const [s, e, l, c] = await Promise.all([
        axios.get(`${API}/settings`, auth()), axios.get(`${API}/editions`, auth()),
        axios.get(`${API}/subscribers`, auth()), axios.get(`${API}/recipients-count`, auth())]);
      setSettings(s.data); setEditions(e.data.editions || []); setSubs(l.data.subscribers || []); setCount(c.data.count);
    } catch (err) { setMsg('Could not load newsletter data. Please log in again.'); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async () => {
    const next = !settings?.enabled;
    if (!next && !window.confirm('Pause the newsletter? No editions will be sent until you switch it on again.')) return;
    await axios.put(`${API}/settings`, { enabled: next }, auth()); load();
  };
  const test = async () => {
    setBusy(true); setMsg('Sending test...');
    try { const r = await axios.post(`${API}/test`, {}, auth()); setMsg('Test sent to: ' + r.data.sent_to.join(', ')); }
    catch (e) { setMsg('Test failed: ' + (e.response?.data?.detail || e.message)); }
    setBusy(false);
  };
  const preview = async () => {
    const r = await axios.get(`${API}/preview`, { ...auth(), responseType: 'text' });
    const w = window.open('', '_blank'); w.document.open(); w.document.write(r.data); w.document.close();
  };
  const download = async () => {
    const r = await axios.get(`${API}/subscribers.csv`, { ...auth(), responseType: 'blob' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(r.data); a.download = 'newsletter-subscribers.csv'; a.click();
  };
  const fmt = (d) => d ? new Date(d).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '';

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: 20, fontFamily: 'Poppins, Arial, sans-serif', background: '#f7f8fa', minHeight: '100vh' }}>
      <button onClick={() => navigate('/dashboard')} style={{ ...btn('#6b7280'), marginBottom: 16 }}>← Dashboard</button>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#1B365D', marginBottom: 16 }}>Aabkari Times Insights – Newsletter</h1>
      {msg && <div style={{ ...box, background: '#FFF8E1', padding: 12 }}>{msg}</div>}

      <div style={box}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'center' }}>
          <div><div style={{ color: '#666', fontSize: 13 }}>Status</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: settings?.enabled ? '#1E7B34' : '#C62828' }}>{settings ? (settings.enabled ? 'ON' : 'PAUSED') : '…'}</div></div>
          <div><div style={{ color: '#666', fontSize: 13 }}>Schedule</div><div style={{ fontWeight: 600 }}>{settings?.send_days} · {settings?.send_time}</div></div>
          <div><div style={{ color: '#666', fontSize: 13 }}>Total readers</div><div style={{ fontSize: 20, fontWeight: 700 }}>{count ?? '…'}</div></div>
          <div><div style={{ color: '#666', fontSize: 13 }}>Website signups</div><div style={{ fontSize: 20, fontWeight: 700 }}>{subs.length}</div></div>
        </div>
        <div style={{ marginTop: 16 }}>
          <button style={btn(settings?.enabled ? '#C62828' : '#1E7B34')} onClick={toggle}>{settings?.enabled ? 'Pause newsletter' : 'Switch ON'}</button>
          <button style={btn('#1E4BA8')} onClick={preview}>Preview next edition</button>
          <button style={btn('#C8960C')} onClick={test} disabled={busy}>Send test to our 4 addresses</button>
        </div>
      </div>

      <div style={box}>
        <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>Past editions</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>Vol</th><th style={th}>Date</th><th style={th}>Subject</th><th style={th}>Status</th><th style={th}>Sent</th><th style={th}>Failed</th></tr></thead>
          <tbody>{editions.length === 0 ? <tr><td style={td} colSpan={6}>No editions yet. The first goes out on the next Tuesday or Friday at 9:30.</td></tr> :
            editions.map((e) => <tr key={e.id}><td style={td}>{e.volume ?? '-'}</td><td style={td}>{e.edition_date}</td><td style={td}>{e.subject || e.reason || ''}</td>
              <td style={td}>{e.status}</td><td style={td}>{e.sent ?? '-'}</td><td style={td}>{e.failed ?? '-'}</td></tr>)}</tbody>
        </table>
      </div>

      <div style={box}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700 }}>Website signups ({subs.length})</h2>
          <button style={btn('#1E7B34')} onClick={download}>Download Excel (CSV)</button>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>#</th><th style={th}>Email</th><th style={th}>Source</th><th style={th}>Status</th><th style={th}>Subscribed on</th></tr></thead>
          <tbody>{subs.length === 0 ? <tr><td style={td} colSpan={5}>No website signups yet.</td></tr> :
            subs.map((s, i) => <tr key={s.email}><td style={td}>{i + 1}</td><td style={td}>{s.email}</td><td style={td}>{s.source}</td><td style={td}>{s.status}</td><td style={td}>{fmt(s.created_at)}</td></tr>)}</tbody>
        </table>
      </div>
    </div>
  );
}
